import axios from "@/lib/axios";

export type CreateResourceLinkRequestParams = {
  companyId: string;
  resourceLibraryId: string;
  name: string;
  description?: string;
  url: string;
  tags?: string[];
};

export type CreateResourceLinkResponse = { id: string };

export const createResourceLink = (params: CreateResourceLinkRequestParams) =>
  axios
    .post<CreateResourceLinkResponse>(
      `/v1/companies/${params.companyId}/resource-libraries/${params.resourceLibraryId}/resources/link`,
      {
        name: params.name,
        url: params.url,
        description: params.description,
        tags: params.tags,
      },
    )
    .then((res) => res.data);
